export default "__VITE_ASSET__24498b38__"